module.exports = __webpack_public_path__ + "static/media/edition-size.512b3871.webp";